<template>
  <div class="control-checkbox">
    <input type="checkbox" class="d-none" v-model="acceptTermsAndConditions" id="term-and-conditions">
    <label
      for="term-and-conditions"
      class="d-block p-2 p-md-3 border border-2 rounded font-gotham-m fs-7"
      :class="[acceptTermsAndConditions ? 'primary-border-color primary-text-color' : 'text-secondary border-secondary']"
    >
      Acepto los <a :class="[termsAndConditionsTextColor]">Términos y Condiciones</a> y la <a :class="[termsAndConditionsTextColor]">Política de Privacidad</a>
    </label>
  </div>
</template>

<script>
export default {
  computed: {
    acceptTermsAndConditions: {
      get() { return this.$store.state.client.acceptTermsAndConditions; },

      set(value) {
        this.$store.commit('setClient', {
          acceptTermsAndConditions: value
        });
      }
    },

    termsAndConditionsTextColor() {
      return this.acceptTermsAndConditions ? 'primary-text-color' : 'text-secondary';
    },
  }
}
</script>